// Track amplitude events
import { UI_TAXONOMY_VERSION } from "../../analytics/amplitude/amplitudeEvents";
import SendEventAPI from "../../api/send-event.api";
import { getBaseEvent } from "./getBaseEvent";

export function trackAmpEvent(event_name: any, event_type: any, payload: any) {
  const record = {
    ...getBaseEvent(event_name, event_type),
    payload: {
      ...payload,
      initialReferrer: document.referrer || "NOT_PRESENT",
      uiTaxonomyVersion: UI_TAXONOMY_VERSION,
      language: window.navigator.language,
    },
  };

  SendEventAPI.sendEventWithPayload([record]);
}
